/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Who_3_TInputs */

const en_cp_who_3_t = /** @type {(inputs: Cp_Who_3_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Campus, incubator, student societies`)
};

const id_cp_who_3_t = /** @type {(inputs: Cp_Who_3_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kampus, inkubator, himpunan`)
};

/**
* | output |
* | --- |
* | "Campus, incubator, student societies" |
*
* @param {Cp_Who_3_TInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_who_3_t = /** @type {((inputs?: Cp_Who_3_TInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Who_3_TInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_who_3_t(inputs)
	return en_cp_who_3_t(inputs)
});